import Button from "../../../components/button/Button";
import checkGreen from '../../../assets/payments/check_circle-green.svg'
import addCircle from '../../../assets/check_circle_outline.svg'
import edit from '../../../assets/edit.svg'
import { useLocation, useNavigate } from "react-router-dom";
import './CreditCardList.css'
import { ICreditCard } from "../../../shared/models/creditCard/creditCard";
import { getTypeCard } from "../../../utils/format";
import { useToast } from "../../../context/ToastModalContext";
import { useBrandContext } from "../../../context/BrandContext";

// Ausente (backend antigo) conta como permitido: so o false explicito bloqueia.
export const isWalletAllowed = (card?: ICreditCard) => card?.wallet_allowed !== false;

interface Props {
    creditCardsList?: ICreditCard[];
    userInfo?: any;

}

const CreditCardList: React.FC<Props> = ({creditCardsList, userInfo}) => {
    const navigate = useNavigate();
    const { showToast } = useToast();
    const location = useLocation();

    const brandContext = useBrandContext();
    // const routePaths = location.pathname.split('/');

    const handleCreditCardButton = (card : ICreditCard) => {

        // O gateway ou a faixa de BIN do cartao nao permitem adicionar credito
        // com ele. Continua na lista para o usuario poder editar ou excluir.
        if (!isWalletAllowed(card)) {
            showToast({
                title: 'Cartão indisponível',
                messageModal: 'Este cartão não pode ser usado para adicionar crédito. Escolha outro cartão ou pague com Pix.',
                allowButtonClosed: true,
                closeButtonText: 'Entendi'
            });
            return;
        }

        if(userInfo?.cpf) {
            navigate(`/${brandContext.brandName}/addCredit/${card.id}`);
        } else {
            showToast({
                title: 'CPF necessário',
                messageModal: 'É necessário atualizar o seu CPF nas suas informações pessoais.',
                textEnterButton: 'Ir para o perfil',
                allowButtonClosed: true,
                handleEnterButton: () =>  navigate(`/${brandContext.brandName}/userProfile`),
                closeButtonText: 'Fechar'
            }) 
        }
    }

    return (
        <>
            {creditCardsList?.sort((a, b) => (a.is_default === b.is_default) ? 0 : a.is_default ? -1 : 1)?.map( (card: ICreditCard, index) => (
                <div key={index} className="credit-card-list-container">
                    <Button
                        style={{marginBottom: '0px', color:`${card?.is_default ? 'var(--Primary-Regular, #3CCC10)' : '#787E7D'}`, backgroundColor: '#fff', border:`${card?.is_default ? '1px solid #3CCC10' : '1px solid #787E7D'}`, opacity: isWalletAllowed(card) ? 1 : 0.5}}
                        type= 'button'
                        children = {<span>{getTypeCard(card?.item_type)} - <b>{card?.description}</b></span>}
                        onClick={() => handleCreditCardButton(card)}
                        spinnerSecondary={true}       
                        image={<img alt="add-button-icon" src={card?.is_default ? checkGreen : addCircle}/>}      
                    />
                    <img onClick={() => navigate(`/${brandContext.brandName}/addCreditCard/${card.id}`)} className="credit-card-edit-button" alt="edit-button-icon" src={edit}/>
                </div>
            ))}
        </>
    )
    
}

export default CreditCardList;